import React from "react";
import { Box, Typography, Link, Divider } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import "./Footer.css";
import { ASSETS_BASE_URL } from "../../config";

const Footer = () => {
	const quickLinks = [
		{ label: "Home", path: "/" },
		{ label: "My Machines", path: "/machines" },
		{ label: "RSPL", path: "/rspl" },
		{ label: "My Lists", path: "/my-lists" },
	];

	const legalLinks = [
		{ label: "Privacy Policy", path: `${ASSETS_BASE_URL}/Legal/Privacy Policy.pdf` },
		{ label: "EULA", path: `${ASSETS_BASE_URL}/Legal/End-User License Agreement (EULA).pdf` },
	];

	const contactInfo = [
		{ icon: <LocationOnIcon className="footer-icon" />, text: "16037 Innovation Dr, South Chesterfield, VA 23834" },
		{ icon: <PhoneIcon className="footer-icon" />, text: "(804) 520-5400", isPhone: true },
		{ icon: <EmailIcon className="footer-icon" />, text: "orders@blueprintautomation.com", isEmail: true },
	];

	return (
		<Box className="footer-main" component="footer" py={4} px={2}>
			<Box display="flex" flexWrap="wrap" justifyContent="space-between" className="footer-container">
				{/* Logo and Description */}
				<Box flex="1 1 250px" mb={2} className="footer-logo-section">
					<Box display="flex" sx={{ justifyContent: "center" }} flexDirection="column" alignItems="start">
						<img src="/logo.png" alt="Ithena logo" className="footer-logo" />
						<Typography variant="body2" className="footer-description">
							BPA - your trusted partner in delivering quality products and innovative solutions.
						</Typography>
					</Box>
				</Box>

				{/* Contact Information */}
				<Box flex="1 1 250px" mb={2} className="footer-contact">
					<Typography variant="h6" className="footer-title">
						Contact Us
					</Typography>
					{contactInfo.map((info, index) => (
						<Box key={index} display="flex" alignItems="center" className="footer-contact-item">
							{info.icon}
							{info.isEmail ? (
								<Link
									href={`mailto:${info.text}`}
									className="footer-link"
									color="inherit"
									variant="body2">
									{info.text}
								</Link>
							) : info.isPhone ? (
								<Link href={`tel:${info.text}`} className="footer-link" color="inherit" variant="body2">
									{info.text}
								</Link>
							) : (
								<Typography variant="body2">{info.text}</Typography>
							)}
						</Box>
					))}
				</Box>

				{/* Main Navigation Links */}
				<Box flex="1 1 250px" mb={2} className="footer-links">
					<Typography variant="h6" className="footer-title">
						Quick Links
					</Typography>
					<Box display="flex" flexDirection="column" className="footer-link-group">
						{quickLinks.map((link, index) => (
							<Link key={index} href={link.path} color="inherit" className="footer-link">
								{link.label}
							</Link>
						))}
					</Box>
				</Box>

				{/* Legal Links */}
				<Box flex="1 1 250px" mb={2} className="footer-legal-links">
					<Typography variant="h6" className="footer-title">
						Legal
					</Typography>
					<Box display="flex" flexDirection="column" className="footer-link-group">
						{legalLinks.map((link, index) => (
							<Link
								key={index}
								href={link.path}
								color="inherit"
								className="footer-link"
								target="_blank"
								rel="noopener noreferrer">
								{link.label}
							</Link>
						))}
					</Box>
				</Box>
			</Box>

			{/* Divider and Copyright */}
			<Divider className="footer-divider" />
			<Box textAlign="center">
				<Typography variant="body2" color="textSecondary">
					&copy; {new Date().getFullYear()} BPA. All rights reserved.
				</Typography>
			</Box>
		</Box>
	);
};

export default Footer;